// extracted by mini-css-extract-plugin
module.exports = {"balance_button":"BalanceButton_balance_button__38pMx","align":"BalanceButton_align__1Q6pB","button_plus":"BalanceButton_button_plus__3J6Yt"};